import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginInfoService } from '@pg-app/auth/services/login-info.service';
import { ResetPasswordService } from '@pg-app/auth/services/reset-password.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'np-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  changePasswordForm: FormGroup;
  passwordPattern = '^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[(!@#$%^&*()_+|~ ={}[:”;<>?,., )]).{8,}$';
  get passwordCtrl() {
    return this.changePasswordForm.get('password') as FormControl;
  }

  get confirmPasswordCtrl() {
    return this.changePasswordForm.get('confirmPassword') as FormControl;
  }

  comparePassword(c: AbstractControl) {
    const v = c.value;
    return v.password === v.confirmPassword
      ? null
      : {
        passwordnotmatch: true
      };
  }

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private loginInfo: LoginInfoService,
    private resetPasswordService: ResetPasswordService,
    public toastr: ToastrService,
  ) { }

  ngOnInit() {
    this.changePasswordForm = this.fb.group(
      {
        password: ['', Validators.compose([Validators.required, Validators.pattern(this.passwordPattern)])],
        confirmPassword: ''
      },
      {
        validator: this.comparePassword
      }
    );
  }

  onSubmit() {
    if (this.changePasswordForm.valid) {
      this.resetPasswordService
        .changePassword({
          tokenHash: this.loginInfo.tokenHash,
          newPassword: this.passwordCtrl.value,
          confirmNewPassword: this.confirmPasswordCtrl.value,
        })
        .subscribe(
          res => {
            this.toastr.success('Reset password successfully!');
            this.router.navigate(['auth/login']);
          }
        );
    }
  }
}
